export const redeemCode = /* GraphQL */ `
  mutation RedeemCode($accountId: ID!, $code: String!, $input: RedeemDetailsInput) {
    redeemCode(accountId: $accountId, code: $code, input: $input)
  }
`;
